import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import MuiDialogAlert from '../components/MuiDialogAlert';

import RoomsAutoComplete from '../components/RoomsAutoComplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';

import LoadingOverlay from 'react-loading-overlay';
const axios = require('axios').default;

const formData = {
  "security_qn_answer" : "",
  "roomId" : ""
}


function AssignRoom() {
  const [loadingActive, setLoadingActive] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading");

  const [modalHeader, setModalHeader] = useState("");
  const [modalBody, setModalBody] = useState("Update Successful");
  const [showModal, setShowModal] = useState(false);
  
  const [roomList, setRoomList] = useState(false);
  const [submitBtnDisable, setSubmitBtnDisable] = useState(true);
  const [showPasswordDiv, setShowPasswordDiv] = useState("hidden");
  const [password, setPassword] = useState("");
  
  let navigate = useNavigate();

  const handleClose = () => setShowModal(false);

  const textInput = React.useRef(null);

  useEffect(() => {
    let url = process.env.REACT_APP_API_SERVER + "/load_parameters";
    setLoadingActive(true);

    axios.post(url, {
      "parameters": "RoomList",
      "api_user": JSON.parse(localStorage.getItem('user'))

    })
      .then(function (response) {
        let data = response.data;

        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        setRoomList(
          data.map((d) => {
            return (d.room_id)
          }
          ))

        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalBody("Error Loading parameters")
        setShowModal(true)
      });
  }, [])

  function updateForm(e) {
    let id = e.target.id;
    let val = e.target.value;

    if (id.includes("roomId")) {
      id = "roomId"
      val = e.target.innerHTML
    }
    formData[id] = val;



    if (formData.security_qn_answer !== "" && formData.roomId !== ""){
      setSubmitBtnDisable(false);
    }
    else{
      setSubmitBtnDisable(true);
    }
  }


  function submitBtnClick(){

    if (formData.security_qn_answer < 120 || formData.security_qn_answer > 220) {
      setModalBody("Please enter a valid height")
      setShowModal(true)
    }
    else{
      let url = process.env.REACT_APP_API_SERVER + "/save_settings";
      setLoadingText("Saving ...")
      setLoadingActive(true);

      axios.post(url, {
        "settings": "security_qn_ans",
        "room_id": formData.roomId,
        "security_qn_ans": formData.security_qn_answer,
        "api_user": JSON.parse(localStorage.getItem('user'))
      })
        .then(function (response) {
          let data = response.data;

          if (response.data.status === "API_AUTH_ERROR") {
            // Force user to re-login if unable to autheticate with the API
            navigate("/logout")
          }

          if (data.status === "OK") {
            // Show password
            showPassword(formData.roomId)
          }

          if (data.status === "ERROR") {
            setModalHeader("Error saving security questions")
            setModalBody(data.err_msg)
            setShowModal(true)
          }
          setLoadingActive(false)
        })
        .catch(function (error) {
          setModalHeader("Error saving security questions")
          setModalBody(error)
          setShowModal(true)
        });
    }

     

  }

  
  function assignAnotherRoomBtnClick(){
    setPassword("")
    setShowPasswordDiv("hidden")
    textInput.current.value = "";
    formData.roomId = ""
    formData.security_qn_answer = ""
  }

  function showPassword(room_id){
    let url = process.env.REACT_APP_API_SERVER + "/get_password";
    setLoadingText("Retriving Password")
    setLoadingActive(true);

    axios.post(url, {
      "room_id": formData.roomId,
      "api_user": JSON.parse(localStorage.getItem('user'))

    })
      .then(function (response) {
        let data = response.data;

        if (response.data.status === "API_AUTH_ERROR") {
          // Force user to re-login if unable to autheticate with the API
          navigate("/logout")
        }

        if (data.status === "OK") {
          // Show password
          setPassword(data.password)
          setShowPasswordDiv("")
          setSubmitBtnDisable(true)
        }

        if (data.status === "ERROR") {
          setModalHeader("Error retriving password")
          setModalBody(data.err_msg)
          setShowModal(true)
        }

        setLoadingActive(false)
      })
      .catch(function (error) {
        setModalHeader("Error retriving password")
        setModalBody(error)
        setShowModal(true)
        setLoadingActive(false)

      });
  }


  return (
    <div align="left" style={{ height: "100%" }}>
      <LoadingOverlay
        active={loadingActive}
        spinner
        text={loadingText}
        className="spinner_div"
      >
        <div className="form_area">
          <div className="page_header">LOGIN CREDENTIALS</div>
            <div style={{height: "8px"}}></div>
            
            <div className="form-labels">Room ID</div>
            <RoomsAutoComplete 
              id="roomId"
              data_list={roomList}
              onChangeFunc={updateForm}
              />

          <div style={{height: "30px"}}></div>

          <div className="page_header">Security</div>

          <div className="form-labels">What is your height in cm?</div>
            <div style={{height: "8px"}}></div>

          <div>
            <table>
              <tr>
                <td>
                  <TextField 
                    id="security_qn_answer" 
                    type="number"
                    size="small"
                    inputRef={textInput}
                    sx={{
                      '& legend': {
                        display: 'none'
                      },
                      '& fieldset': { top: 0 },
                      width: 100
                    }}
                    onChange={updateForm} 
                  />
                </td>
                <td className="f_18px">&nbsp;cm</td>

              </tr>

            </table>
          </div>

            <div style={{height: "30px"}}></div>

          <div>
            <Button 
              variant="contained" 
              color="success"
              onClick={submitBtnClick}
              sx={{ width: 300, height: 50 }}
              disabled={submitBtnDisable}
            >
              Submit
            </Button>
          </div>

          <div style={{ height: "30px" }}></div>

          <div className={showPasswordDiv}>
            <div style={{width: "300px", height: "120px", border: "solid 1px black"}}>
              <div className='f' style={{ fontSize: "18px", paddingLeft: "10px", paddingTop: "10px" }}>
                Password</div>
              <div className='f' style={{ fontSize: "36px", fontWeight: "900",  padding: "10px" }}>
                {password}</div>
            </div>

            <div style={{ height: "30px" }}></div>

            <div>
              <Button
                variant="contained"
                color="info"
                onClick={assignAnotherRoomBtnClick}
                sx={{ width: 300, height: 50 }}
              >
                Assign Another Room
              </Button>
            </div>

          </div>

          <MuiDialogAlert
            showModal={showModal}
            handleClose={handleClose}
            bodyContent={modalBody}
            title={modalHeader}
            bodyClass="whitespace"
          />

        </div>
      </LoadingOverlay>
    </div>
  )
}

export default AssignRoom